var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.15909 12H5.31818C4.91526 12 4.51629 11.9224 4.14404 11.7716C3.77179 11.6209 3.43356 11.3999 3.14865 11.1213C2.57325 10.5587 2.25 9.79565 2.25 9C2.25 8.20435 2.57325 7.44129 3.14865 6.87868C3.72405 6.31607 4.50445 6 5.31818 6H7.15909M10.4442 6H12.6818C13.0847 6 13.4837 6.0776 13.856 6.22836C14.2282 6.37913 14.5664 6.6001 14.8513 6.87868C15.1363 7.15726 15.3623 7.48797 15.5164 7.85195C15.6706 8.21593 15.75 8.60603 15.75 9C15.75 9.39397 15.6706 9.78407 15.5164 10.1481C15.3623 10.512 15.1363 10.8427 14.8513 11.1213C14.5664 11.3999 14.2282 11.6209 13.856 11.7716C13.4837 11.9224 13.0847 12 12.6818 12H10.4442M6.75 9H11.25",
    stroke: "currentColor",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.bed41f019b502956ce38adae9696782c.svg";
export { ForwardRef as ReactComponent };